﻿import Vue from "vue";
import Component from "vue-class-component";
import common from "../../../common";
import HotEditableFormManager_ from "./HotEditableFormManager";
import utilities_ from "../../utilities";
import HotEditableHelpers_ from "./HotEditableHelpers";

const utilities = require("../../utilities") as typeof utilities_;
// const HotEditableFormManager = require("./HotEditableFormManager") as HotEditableFormManager_;
// const HotEditableHelpers = require("./HotEditableHelpers") as HotEditableHelpers_;

declare function __getHotEditableDocumentsUploadComponentTemplate(): string;

interface IElementValue {
    id?: string;
    fileName?: string;
    fileUrl?: string;
    /** utilise dans le typescript seulement pour differencier 2 elementValue */
    timestamp?: number | null;
}
interface IFileInformation {
    id: string;
    fileName: string;
}
interface IFileMessage {
    /** Requis pour les boucles 'v-for'. */
    id: string;
    textHtml: string;
    isError: boolean;
}
@Component({
    props: {
        initId: String,
        initName: String,
        initClass: String,
        initCssOptions: String,
        initValue: Array<Object>,
        initEmptyValue: Object,
        initDefaultValue: String,
        initTabIndex: Number,
        initDisplayName: String,
        initRequired: String,
        initDisabled: String,
        initPlaceholder: String,
        initEditModeOn: Boolean,
        initCanChangeEditMode: Boolean,
        initClearable: Boolean,
        initButtonTextAdd: String,
        initButtonTextChange: String,
        initAccept: String,
        initMaxFiles: Number,
        initMaxFileSizeMb: Number
    }
})
class HotEditableDocumentsUploadComponent extends Vue implements common.IHotEditableFieldComponent {

    initId?: string;
    initName?: string;
    initClass?: string;
    initCssOptions?: string;
    initValue?: IElementValue[];
    initEmptyValue?: IElementValue;
    initDefaultValue?: string;
    initTabIndex?: number;
    initDisplayName?: string;
    initPlaceholder?: string;
    initRequired?: string;
    initDisabled?: string;
    initEditModeOn?: boolean;
    initCanChangeEditMode?: boolean;
    initClearable?: boolean;
    initAccept?: string;
    initButtonTextAdd?: string;
    initButtonTextChange?: string;
    initMaxFiles?: number;
    initMaxFileSizeMb?: number;

    rootId?: string;
    editModeOn?: boolean;
    canChangeEditMode?: boolean;
    elementValue?: IElementValue[] | null;
    emptyValue?: IElementValue;
    defaultValue?: string;
    tabIndex?: number;
    required?: boolean;
    disabled?: boolean;
    placeholder?: string;
    elementName?: string;
    idElement?: string;
    displayName?: string;
    cssClass?: string;
    cssOptions?: string;
    clearable?: boolean;
    clearableCurrent?: boolean;
    accept?: string;
    maxFiles?: number;
    maxFileSizeMb?: number;
    fileMessages?: IFileMessage[];
    buttonTextAdd?: string;
    buttonTextChange?: string;
    hasError?: boolean;
    isInitialized?: boolean;
    fieldType = common.HotEditableFieldTypes.documentUpload;

    _isApiRunning = false;
    _previousValue? = [] as IElementValue[] | null;//NOTE?: Doit etre NULL (defined) car il est definie dans le "created" (vue)
    _formManager?: HotEditableFormManager_ | null;//NOTE?: Doit undefined initialement car il est definie dans le "beforeCreate" (vue)

    static tagName = "hoteditabledocumentsupload";
    // static prepareMarkup(element: HTMLElement) {
    //     if (!element)
    //         throw "[" + this.tagName + "::prepareMarkup] L'element est NULL";
    //     element.removeAttribute("hot-editable");
    //     element.setAttribute("hot-editable-cloak", "");
    //     const newOuterHtml = element.outerHTML.replace('<input ', '<' + this.tagName + ' ')
    //         .replace(' type="file"', ' ')
    //         .replace(' id=', ' init-id=')
    //         .replace(' name=', ' init-name=')
    //         .replace(' class=', ' init-class=')
    //         .replace(' css-options=', ' init-css-options=')
    //         .replace(' value=', ' v-bind:init-value=')
    //         .replace(' empty-value=', ' v-bind:init-empty-value=')
    //         .replace(' default-value=', ' init-default-value=')
    //         .replace(' required=', ' init-required=')
    //         .replace(' disabled=', ' init-disabled=')
    //         .replace(' placeholder=', ' init-placeholder=')
    //         .replace(' display-name=', ' init-display-name=')
    //         .replace(' clearable=', ' v-bind:init-clearable=')
    //         .replace(' tabindex=', ' v-bind:init-tab-index=')
    //         .replace(' upload-api-url=', ' init-upload-api-url=')
    //         .replace(' delete-api-url=', ' init-delete-api-url=')
    //         .replace(' button-text-add=', ' init-button-text-add=')
    //         .replace(' button-text-change=', ' init-button-text-change=')
    //         .replace(' accept=', ' init-accept=')
    //         .replace(' edit-mode-on=', ' v-bind:init-edit-mode-on=')
    //         .replace(' can-change-edit-mode=', ' v-bind:init-can-change-edit-mode=');
    //     element.outerHTML = newOuterHtml;
    // }

    data() {
        const defaultValues = {
            emptyValue: {
                fileName: "Aucun document"
            } as IElementValue,
            buttonTextAdd: 'Ajouter',
            buttonTextChange: 'Modifier',
            placeholder: 'Sélectionner un ou plusieurs documents',
            maxFiles: 10,
            maxFileSizeMb: 20
        };
        const guid = utilities.createGuid('N');
        const id = this.initId || "Field_" + guid;
        const value = this.initValue || [] as IElementValue[];
        const isClearable = this.initClearable === true;
        const o = {
            rootId: "HotEditableField_" + guid,
            idElement: id,
            elementName: this.initName || id,
            editModeOn: this.initEditModeOn === true,
            canChangeEditMode: this.initCanChangeEditMode === true,
            elementValue: value,
            emptyValue: this.initEmptyValue || defaultValues.emptyValue,
            defaultValue: this.initDefaultValue || '',
            tabIndex: this.initTabIndex,
            displayName: this.initDisplayName || null,
            required: this.initRequired === 'required',
            disabled: this.initDisabled === 'disabled',
            placeholder: this.initPlaceholder || defaultValues.placeholder,
            cssClass: this.initClass || '',
            cssOptions: this.initCssOptions || '|none|',
            clearable: isClearable,
            clearableCurrent: isClearable,
            accept: this.initAccept || '',
            buttonTextAdd: this.initButtonTextAdd || defaultValues.buttonTextAdd,
            buttonTextChange: this.initButtonTextChange || defaultValues.buttonTextChange,
            hasError: false,
            isInitialized: false,
            maxFiles: this.initMaxFiles || defaultValues.maxFiles,
            maxFileSizeMb: this.initMaxFileSizeMb || defaultValues.maxFileSizeMb,
            fileMessages: [] as IFileMessage[]
        };
        return o;
    }

    updatePreviousValue(value?: IElementValue[]) {
        this._previousValue = value || this.copyElementValue();
        return this;
    }

    changeMode(canChangeEditMode?: boolean, editModeOn?: boolean) {
        this.updatePreviousValue();
        this.canChangeEditMode = canChangeEditMode;
        this.editModeOn = editModeOn;
    }

    isClearable() {
        return this.clearable && this.clearableCurrent;
    }
    private updateClearableCurrent(value?: boolean) {
        value = value === true || value === false ? value : this.hasSettedFile();
        this.clearableCurrent = value;
    }

    /** Format: id1|fileName1|previewUrl1|fileUrl1,id2|fileName2|previewUrl2|fileUrl2,...etc */
    setFromTextualValue(textualValue?: string) {
        textualValue = textualValue || '';

        if (!textualValue) {
            this.elementValue = [];
            this.updateClearableCurrent();
            return this;
        }

        const value = [] as IElementValue[];
        const parts = textualValue.split(',');
        const append = (part: string) => {
            const subParts = part.split('|');
            if (subParts.length < 2)
                throw "[HotEditableDocumentsUpload::setFromTextualValue] La valeur textuelle est invalide ([id|fileName|fileUrl,...]).";

            const id = subParts[0] || '';
            const fileName = subParts[1] || '';
            const fileUrl = subParts[2] || '';
            const timespan = !id ? null : this.getCurrentTimespan();

            value.push({
                id: id,
                fileName: fileName,
                timestamp: timespan,
                fileUrl: this.appendTimespan(fileUrl, timespan)
            });
        }

        for (let i = 0; i < parts.length; i++)
            append(parts[i]);

        this.updatePreviousValue();
        this.elementValue = value.sort((a, b) => (a.timestamp || 0) - (b.timestamp || 0));
        this.elementValue = value.sort((a, b) => (a.timestamp || 0) - (b.timestamp || 0));

        var hasFile = this.hasSettedFile();

        this.updateClearableCurrent(hasFile);

        if (!hasFile)
            this.resetInputFile();

        return this;
    }
    /** Format: id1|fileName1|previewUrl1|fileUrl1,id2|fileName2|previewUrl2|fileUrl2,...etc */
    getTextualValue() {
        const value = (this.elementValue || []).sort((a, b) => (a.timestamp ?? 0) - (b.timestamp ?? 0));
        var r = '';
        const append = (v: IElementValue) => {
            if (r)
                r += ',';
            r += '{a}|{b}|{c}'
                .replace("{a}", v.id || '')
                .replace("{b}", v.fileName || '')
                .replace("{c}", v.fileUrl || '');
        };
        for (let i = 0; i < value.length; i++)
            append(value[i]);
        return r;
    }

    created() {
    }

    mounted() {
        HotEditableHelpers_.validateFieldSettings(this);

        (this.$el as Element).removeAttribute("hot-editable-cloak");

        this.updatePreviousValue();
        this.updateClearableCurrent();

        // // permet de faire fonctionner le blur
        // document.addEventListener("mousedown", e => {
        //     if (!this.canChangeEditMode || !this.editModeOn)
        //         return;
        //     const root = this.$refs["root"] as Element;

        //     if (utilities.isOutsideElement(e.target as Element, root))
        //         this.onBlur(e);
        // });
    }

    onButtonClick(event?: Event) {
        this.preventDefault(event, true);
        this.selectFile();
    }

    onSummaryClick(event: Event) {
        this.preventDefault(event);

        if (this.isReadonly())
            return;

        this.selectFile();
    }
    onFileSelected(event: Event) {
        if (this.isReadonly())
            return;

        const r = utilities.getFilesFromInput(this.getInputInstance(), this.maxFiles, this.maxFileSizeMb);

        // reset
        this.fileMessages = [];

        // gestion des erreurs
        const appendErrorMessage = (textHtml: string | null) => this.fileMessages?.push(this.createFileMessage(textHtml, true));
        if (r.hasMaxFilesError)
            appendErrorMessage(r.maxFilesErrorMessage);
        if (r.hasMaxFileSizeMbErrors)
            if (r.maxFileSizeMbErrorMessages)
                for (let i = 0; i < r.maxFileSizeMbErrorMessages.length; i++)
                    appendErrorMessage(r.maxFileSizeMbErrorMessages[i]);

        if (this.hasFileErrors()) {
            this.elementValue = [];
            this.resetInputFile();
        }

        else {
            var value = [] as IElementValue[];
            const append = (x: File) => {
                const name = x ? (x.name || '').trim() : '';
                if (name && !name.endsWith('.exe'))
                    value.push({
                        id: utilities.emptyGuid("N"),
                        fileName: x.name,
                        timestamp: this.getCurrentTimespan()
                    });
            };
            if (r.files)
                for (let i = 0; i < r.files.length; i++)
                    append(r.files[i]);
            this.elementValue = value.sort((a, b) => (a.timestamp || 0) - (b.timestamp || 0));
        }

        // Donne le temps a hidden field (ID) d'etre modifie
        this.$nextTick(() => {
            this.changed();
        });
    }
    private createFileMessage(textHtml: string | null, isError?: boolean) {
        isError = isError === true;//default=FALSE
        return {
            id: utilities.createGuid('N'),
            textHtml: textHtml || '',
            isError: isError
        } as IFileMessage
    }
    private hasFileErrors() {
        if (this.fileMessages)
            for (let i = 0; i < this.fileMessages.length; i++)
                if (this.fileMessages[i].isError)
                    return true;
        return false;
    }
    // private getMaxFilesMessage() { return "Le nombre maximum des fichiers pouvant être téléversé est {x}.".replace("{x}", this.maxFiles.toString()); }
    // private getMaxFileSizeMoMessage() { return "Le poid maximum des fichiers pouvant être téléversé est {x}mo.".replace("{x}", this.maxFileSizeMb.toString()); }
    private preventDefault(e?: Event, bypassStopPropagation?: boolean) {
        if (!e)
            return;

        e.preventDefault();

        if (bypassStopPropagation !== true)
            e.stopPropagation();
    }
    selectFile() {
        const instance = this.getInputInstance();
        instance.value = null as any;
        instance.click();
    }

    isReadonly() {
        return !this.editModeOn && !this.canChangeEditMode;
    }
    getFileUrl(value: IElementValue) {
        return value && value.fileUrl ? value.fileUrl : '';
    }
    getInputInstance() {
        return this.$refs["inputInst"] as HTMLInputElement;
    }
    getPlaceholder(value: IElementValue[]) {
        return this.hasSettedFile(value) ? '<em>(contient des fichiers)</em>' : this.placeholder;
    }
    _defaultFileName = 'Document sans nom';
    getInformations(value: IElementValue[]) {
        const r = [] as IFileInformation[];
        if (value)
            for (let i = 0; i < value.length; i++)
                r.push({
                    id: utilities.createGuid("N"),
                    fileName: value[i].fileName || this._defaultFileName
                });
        return r;
    }
    getFileNames(value: IElementValue[]) {
        const r = [] as string[];
        if (this.hasSettedFile(value)) {
            if (value)
                for (let i = 0; i < value.length; i++)
                    r.push(value[i].fileName?.trim() || this._defaultFileName);
            return r;
        }

        return r;
    }
    /** Format : id1,id2,...etc */
    getHiddenFieldValue(value: IElementValue[]) {
        var r = '';
        const append = (x: IElementValue) => {
            if (!x)
                return;
            if (r)
                r += ',';
            if (!x.id)
                throw "[HotEditableDocumentsUploadComponent] Le ID est NULL (IElementValue)";
            r += x.id;
        };
        if (value)
            for (let i = 0; i < value.length; i++)
                append(value[i]);
        return r;
    }
    getButtonText(value: IElementValue) {
        return value && value.id ? this.buttonTextChange : this.buttonTextAdd;
    }
    copyElementValue() {
        if (!this.elementValue)
            return this.elementValue;
        const value = [] as IElementValue[];
        for (let i = 0; i < this.elementValue.length; i++)
            value.push({
                id: this.elementValue[i].id,
                fileName: this.elementValue[i].fileName,
                timestamp: this.elementValue[i].timestamp
            })
        return value;
    }
    isSameElementValue(a: IElementValue[] | null, b?: IElementValue[] | null) {
        if (!a && !b)
            return true;
        if (!a || !b)
            return false;
        if (a.length !== b.length)
            return false;
        for (let i = 0; i < a.length; i++)
            if (a[i].timestamp !== b[i])//&& a.id === b.id && a.fileName === b.fileName 
                return false;
        return true;
    }
    beforeCreate() {
        this._formManager = ((this.$parent as any).formManager as HotEditableFormManager_).registerField(this);
        this.$options.template = __getHotEditableDocumentsUploadComponentTemplate();
    }

    // editClick(event?: Event | null, forcedMode?: boolean) {
    //     return;

    //     // if (!this.canChangeEditMode)
    //     //     return;

    //     // this.updatePreviousValue();

    //     // if (forcedMode === true || forcedMode === false) {
    //     //     this.editModeOn = forcedMode;
    //     // } else {
    //     //     //toggle
    //     //     this.editModeOn = !this.editModeOn;
    //     // }

    //     // if (this.editModeOn)
    //     //     this.updateClearable();

    //     // this._formManager.editModeChanged(this);

    //     //this.focus();
    // }

    onEnterClick(event?: KeyboardEvent) {
        if (this.canChangeEditMode)
            this.preventDefault(event);

        this.changed();
    }

    onEscapeClick(event?: KeyboardEvent) {
        if (this.canChangeEditMode)
            this.preventDefault(event);

        this.cancel();
    }

    onCancel(event: Event) {
        this.preventDefault(event);
        this.cancel();
    }

    onClear(event: Event) {
        this.preventDefault(event);
        this.clear();
    }

    clear() {
        this.elementValue = [];
        this.resetInputFile();
        this.$nextTick(() => {
            this.changed();
        });
    }

    resetInputFile() {
        this.getInputInstance().value = '';
    }

    changed() {
        this.elementValue = this.elementValue || [];
        this.updateClearableCurrent();

        if (this.canChangeEditMode) {
            this.editModeOn = false;
            this._formManager?.editModeChanged(this);
            if (this.isSameElementValue(this.elementValue, this._previousValue))
                return;
        }

        this._formManager?.fieldChanged(this);
    }

    cancel() {
        if (!this.canChangeEditMode)
            return;

        this.elementValue = this._previousValue;

        this.editModeOn = false;

        //NOTE: Le "blur()" va lancer le "changed()"
        //this.$root.$emit('hotEditableTextbox-editModeChanged', this);
    }

    // blur() {
    //     //this.changed();
    //     //setTimeout(() => { this.changed(true); }, 250);
    // }

    // focus() {
    //     // this.$nextTick(() => {
    //     //     this.getInputInstance().focus();
    //     // });
    // }

    hasSettedFile(value?: IElementValue[]) {
        value = value || this.elementValue || [];

        for (let i = 0; i < value.length; i++)
            if (!!value[i].timestamp)
                return true;
        return false;
    }

    /** retournera EMPTY si l'url est vide */
    private appendTimespan(url: string, timespan?: number | null) {
        const updatedUrl = url
            ? url + (url.indexOf('?') < 0 ? '?' : '&') + 't=' + (timespan || this.getCurrentTimespan())
            : '';
        return updatedUrl;
    }

    private getCurrentTimespan() { return Date.now(); }

    // onTabClick(event?: KeyboardEvent) {
    //     //NOTE: Not used in the textbox because the tab has a builtin behavior to blur and blur() method will call the changed() method.
    //     if (event.shiftKey) {
    //         this.onShiftTabClick(event);
    //         return;
    //     }

    //     this.focusNextComponent();

    //     if (event && this.canChangeEditMode) {
    //         event.preventDefault();
    //         event.stopPropagation();
    //     }
    // }

    // onShiftTabClick(event?: KeyboardEvent) {
    //     //NOTE: Not used in the textbox because the tab has a builtin behavior to blur and blur() method will call the changed() method.
    //     this.focusNextComponent(true);

    //     if (event && this.canChangeEditMode) {
    //         event.preventDefault();
    //         event.stopPropagation();
    //     }
    // }

    // private focusNextComponent(getPrevious?: boolean) {
    //     getPrevious = getPrevious === true;

    //     if (!this.canChangeEditMode)
    //         return false;

    //     this.changed();
    //     this.editClick(null, false);

    //     if (getPrevious)
    //         this._formManager.focusPreviousComponentFromField(this)
    //     else
    //         this._formManager.focusNextComponentFromField(this);
    // }

}

export = HotEditableDocumentsUploadComponent;